module.exports = __webpack_public_path__ + "static/media/privacy-policy.3a9ec7dd.txt";